export const locale = {
    lang: 'fr',
    data: {
        LIST_WHERE_TO_PLACE: 'Dans quelle liste souhaiteriez-vous placer ces cartes?',
        LIST_ACTIVITY: 'Liste',
        CANCEL: 'Annuler',
        SAVE: 'Enregistrer',
    }
};
